import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { 
  LuCompass, 
  LuCircleHelp,
  LuRss
} from "react-icons/lu"
import "./NavbarDashboard.css"

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false)
  const [logoLoaded, setLogoLoaded] = useState(false)

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto"
  }, [menuOpen])

  useEffect(() => {
    setMenuOpen(false)
    document.body.style.overflow = "auto"
  }, [location.pathname])

  const handleNavigate = (path) => {
    setMenuOpen(false)
    document.body.style.overflow = "auto"
    navigate(path)
  }

  const handleLogoClick = () => {
    setMenuOpen(false)
    document.body.style.overflow = "auto"

    if (location.pathname !== "/dashboard") {
      navigate("/dashboard")
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" })
    }
  }

  return (
    <>
      <div 
        className={`mobile-overlay ${menuOpen ? "active" : ""}`} 
        onClick={() => setMenuOpen(false)}
      />

      <div className="navbar-wrapper">
        <nav className="navbar">

          <div 
            className="nav-left"
            onClick={handleLogoClick}
            style={{ cursor: "pointer" }}
          >
            {!logoLoaded && <div className="logo-skeleton"></div>}

            <img
              src="/assets/logo.png"
              alt="logo"
              className={`nav-logo ${logoLoaded ? "logo-show" : "logo-hide"}`}
              onLoad={() => setLogoLoaded(true)}
            />
          </div>

          <div className={`nav-links ${menuOpen ? "active" : ""}`}>

            <button 
              className="gold-btn"
              onClick={() => handleNavigate("/dashboard/explore")}
            >
              <LuCompass className="nav-icon" />
              Explore
            </button>

            <button 
              className="contact-btn"
              onClick={() => handleNavigate("/dashboard/feed")}
            >
              <LuRss className="nav-icon" />
              Feed
            </button>

          </div>

          <div
            className={`hamburger ${menuOpen ? "active" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>

        </nav>
      </div>
    </>
  )
}

export default Navbar